var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 40,
    r: 40,
    fill: "#30444E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inner-circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0988 72.1975C49.6119 72.1975 57.7763 68.8157 63.796 62.796C69.8157 56.7763 73.1975 48.6119 73.1975 40.0988C73.1975 31.5856 69.8157 23.4212 63.796 17.4015C57.7763 11.3818 49.6119 8 41.0988 8C32.5856 8 24.4212 11.3818 18.4015 17.4015C12.3818 23.4212 9 31.5856 9 40.0988C9 48.6119 12.3818 56.7763 18.4015 62.796C24.4212 68.8157 32.5856 72.1975 41.0988 72.1975Z",
    fill: "#F97953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "triangle",
    d: "M53.8324 36.2544C57.2002 38.2093 57.1393 43.0936 53.7239 44.964L38.2759 53.4241C34.9345 55.254 30.8559 52.8241 30.8743 49.0145L30.9583 31.6355C30.9768 27.7921 35.1444 25.4059 38.4684 27.3355L53.8324 36.2544Z",
    fill: "#30444E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Play.95bfb29f9c9a5e221b241e5883a90999.svg";